import { map } from 'lodash'

import { areSameValue } from '../../core/utils'

import { findNodeByFilter } from '../../common/utils'

import { getMenuTitlesWithParents } from '../../menu-title/helpers'
import {
  computeDishHighlights,
  computeDishHighlightsFields,
  computeDishHighlightsSources,
} from '../helpers'

export const transformDishesToListView = (
  dishes,
  menuTitles,
  highlightsFromLabelLegends,
) =>
  map(dishes, dish => {
    const selectedMenuTitle = dish.menuTitle
      ? findNodeByFilter(menuTitles, ({ id }) =>
          areSameValue(id, dish.menuTitle?.id),
        )
      : null

    const menuTitleParents = getMenuTitlesWithParents(
      selectedMenuTitle,
      menuTitles,
    )

    const highlights = computeDishHighlights(
      computeDishHighlightsSources(dish, highlightsFromLabelLegends),
      computeDishHighlightsFields(dish, menuTitleParents),
    )

    return {
      ...dish,
      menuTitleParents,
      highlights,
    }
  })
